(function () {
  const initTestimonials = () => {
    document.querySelectorAll(".testimonials-main").forEach((section) => {
      if (section.classList.contains("testimonials-main--initialized")) {
        return;
      }

      const slider = section.querySelector(".testimonials-main__slider");
      if (!slider || typeof Swiper === "undefined") {
        return;
      }

      const autoplay = section.dataset.autoplay === "true";
      const stopAutoplay = section.dataset.stopAutoplay === "true";
      const delay = Number(section.dataset.delay || 4) * 1000;
      const speed = Number(section.dataset.speed || 0.8) * 1000;
      const desktopSlides = Number(section.dataset.slidesDesktop || 2);
      const track = slider.querySelector(".testimonials-main__track");
      const originalSlides = track ? Array.from(track.children) : [];
      const desktopVisibleSlides = Math.min(desktopSlides, originalSlides.length || desktopSlides);

      if (track && originalSlides.length > 1) {
        originalSlides.forEach((slide) => {
          const duplicateSlide = slide.cloneNode(true);
          duplicateSlide.setAttribute("aria-hidden", "true");
          duplicateSlide.classList.add("testimonials-main__slide--duplicate");
          track.appendChild(duplicateSlide);
        });
      }

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const paginationEl = section.querySelector(".testimonials-main__pagination");
      const nextEl = section.querySelector(".testimonials-main__button--next");
      const prevEl = section.querySelector(".testimonials-main__button--prev");
      const realSlideCount = originalSlides.length;

      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: speed,
        loop: false,
        slidesPerGroup: 1,
        watchOverflow: false,
        keyboard: true,
        autoplay: autoplay
          ? {
              delay: delay,
              disableOnInteraction: false,
            }
          : false,
        breakpoints: {
          750: {
            slidesPerView: Math.min(desktopSlides, 2),
            spaceBetween: 0,
          },
          1100: {
            slidesPerView: desktopVisibleSlides,
            spaceBetween: 0,
          },
        },
      };

      const swiper = new Swiper(slider, swiperOptions);

      if (paginationEl && realSlideCount > 1) {
        paginationEl.innerHTML = "";

        const updatePagination = () => {
          const activeIndex = swiper.activeIndex % realSlideCount;
          paginationEl
            .querySelectorAll(".swiper-pagination-bullet")
            .forEach((bullet, index) => {
              const isActive = index === activeIndex;
              bullet.classList.toggle("swiper-pagination-bullet-active", isActive);
              bullet.setAttribute("aria-current", isActive ? "true" : "false");
            });
        };

        originalSlides.forEach((slide, index) => {
          const bullet = document.createElement("button");
          bullet.type = "button";
          bullet.className = "swiper-pagination-bullet";
          bullet.setAttribute("aria-label", `Go to review ${index + 1}`);
          bullet.addEventListener("click", () => {
            swiper.slideTo(index);
          });
          paginationEl.appendChild(bullet);
        });

        swiper.on("slideChange", updatePagination);
        swiper.on("transitionEnd", () => {
          if (swiper.activeIndex >= realSlideCount) {
            swiper.slideTo(swiper.activeIndex % realSlideCount, 0);
          }
        });
        updatePagination();
      }

      if (nextEl && prevEl && realSlideCount > 1) {
        nextEl.addEventListener("click", () => {
          if (swiper.activeIndex >= realSlideCount) {
            swiper.slideTo(1);
            return;
          }

          swiper.slideNext();
        });

        prevEl.addEventListener("click", () => {
          if (swiper.activeIndex === 0) {
            swiper.slideTo(realSlideCount - 1);
            return;
          }

          swiper.slidePrev();
        });
      }

      section.classList.add("testimonials-main--initialized");

      if (autoplay && stopAutoplay) {
        section.addEventListener("mouseenter", () => swiper.autoplay.stop());
        section.addEventListener("mouseleave", () => swiper.autoplay.start());
      }

      const revealTarget = section.querySelector(".observe-me");
      if (revealTarget) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              revealTarget.classList.add("is-inview");
              if (autoplay) {
                swiper.autoplay.stop();
              }

              observer.unobserve(revealTarget);

              setTimeout(() => {
                revealTarget.classList.remove("is-inview");
                revealTarget.classList.remove("observe-me");
                if (autoplay) {
                  swiper.autoplay.start();
                }
              }, 600);
            });
          },
          { threshold: 0.1 }
        );

        observer.observe(revealTarget);
      }
    });
  };

  document.addEventListener("DOMContentLoaded", initTestimonials);
  document.addEventListener("shopify:section:load", initTestimonials);
})();
